import ThumbUpSvg from '@helpers/resources/ThumbUpSvg'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'

const SuscripcionRealizada = () => {
  return (
    <Container fluid style={{display:'flex', flexDirection: 'column', alignContent: 'center', justifyContent: "center", height: "100vh", backgroundColor: "#ff9900"}}>
        <Row className='my-5 p-5 rounded flex flex-row align-items-center w-75 ' style={{backgroundColor: "#212529", color: '#fff', height: "50vh"}}>
            <Col lg={6} className='text-center'>
                <div>
                    <ThumbUpSvg />
                <h2 className='mt-4'>¡Compra realizada!</h2>
                </div>
            </Col>

            <Col lg={6} className='p-3 rounded' style={{backgroundColor: "#f2f2f2", color: "#21259"}}>
                <p>Has adquirido:</p>
                <h4>Licencia Click Academy Ofimática</h4>
                <div>
                    <span>Incluye:</span>
                    <ul>
                        <li>Paquete Ofimática básico (Excel, PowerPoint, Word, PowerBI)</li>
                    </ul>
                </div>

                <div className='text-center mt-4 p-3'>
                    <span>Recibirás un correo electrónico de <b>notificaciones@globalclickmexico.com</b> con las instrucciones para completar tu registro en la plataforma.</span>
                </div>
            </Col>
        </Row>
    </Container>
  )
}

export default SuscripcionRealizada